export default "__VITE_ASSET__51f813a8__"